<template>
   <el-dialog title="上传记录" v-model="dialogVisible" :modal-append-to-body="false">
      <el-table :data="dataList" style="width: 100%">
         <el-table-column align="center" label="文件名" prop="fileName"></el-table-column>
         <el-table-column align="center" label="用户" prop="uploader"></el-table-column>
         <el-table-column align="center" label="时间">
            <template scope="{ row }">
               <span>{{ row.createTime ? new Date(row.createTime).format("yyyy-MM-dd hh:mm:ss") : '' }}</span>
            </template>
         </el-table-column>
         <el-table-column align="center" label="状态" prop="name">
            <template scope="{ row }">
               <span>{{ handleStatus(row) }}</span>
            </template>
         </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
         <el-pagination v-show="total > 0" layout="prev, pager, next" :current-page="queryParam.pageNum"
            :page-size='queryParam.pageSize' :total="total" @current-change="changeCurrentPage">
         </el-pagination>
      </div>
   </el-dialog>
</template>

<script>
export default {
   props: {
      schoolId: {
         type: String,
         default: ''
      },
      uid: {
         type: String,
         default: ''
      },
      visible: {
         type: Boolean,
         default: false
      },
   },

   data() {
      return {
         queryParam: {
            schoolId: '',
            uid: '',
            pageNum: 1,
            pageSize: 10,
         },
         total: 0,
         dataList: []
      }
   },

   computed: {
      dialogVisible: {
         get: function () {
            return this.visible;
         },
         set: function (value) {
            this.$emit('update:visible', value);
         }
      }
   },

   watch: {
      visible(value) {
         if (value) {
            this.queryParam.schoolId = this.schoolId;
            this.queryParam.uid = this.uid;
            this.queryList();
         }
      }
   },

   methods: {
      // 查询硬件防作弊配置上传记录列表
      queryList() {
         this.$http({
            url: this.$util.aioIP + '/api/m/sys/config/file/v365/task/list',
            method: 'get',
            params: this.queryParam,
            headers: { channelCode: this.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj' },
         }).then((res) => {
            this.total = res.data.data.total || 0;
            this.dataList = res.data.data.content || [];
         }).catch((err) => {
            this.total = 0;
            this.dataList = [];
         });
      },
      // 切换页码
      changeCurrentPage(value) {
         this.queryParam.pageNum = value;
         this.queryList();
      },
      // 处理状态
      handleStatus(row) {
         if (row.handleStatus == 0) {
            return '处理中';
         } else if (row.handleStatus == 1) {
            return '成功';
         } else if (row.handleStatus == 2) {
            return '失败，' + row.incorrectReason;
         } else {
            return '';
         }
      }
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// HardwareRecord.vue?58d16014